<template>
    <div>
        <div v-if="donationSuccess" class="rounded-md bg-green-200 mb-10 ">
            <div class="mx-auto max-w-7xl px-4  sm:px-6 lg:px-8">
                <div class="flex p-4 ">
                    <div class="flex-shrink-0">
                        <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="ml-3">
                        <h3 class="text-sm font-medium text-green-800">Payment successful! </h3>
                        <div class="mt-2 text-sm text-green-700">
                            <p> Your payment has been completed successfully.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-6 ">
            <div class="flex flex-col items-center gap-1 mt-4 sm:mt-0">
                <p class="text-2xl sm:text-3xl font-extrabold text-gray-900 text-center">Your {{ REGISTRATION_YEAR }}
                    Property Tax Protest Results</p>
                <p class="text-base text-gray-500">{{ countyName }}</p>
            </div>
            <div
                class="flex-col flex gap-6 sm:py-10 py-8 px-2 sm:px-6 lg:px-8 max-w-5xl sm:m-auto  sm:shadow-lg sm:rounded-lg sm:bg-white sm:border sm:border-gray-200">
                
                <div v-if="userProperties.length > 1">
                    <div class="rounded-xl border border-gray-200 bg-white overflow-hidden">
                        
                        <!-- Header -->
                        <div class="p-3 border-b border-gray-200 bg-gray-50">
                            <h3 class="text-base font-semibold text-gray-900">
                                Protest Summary
                            </h3>
                        </div>

                        <!-- Summary -->
                        <div class="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-gray-200">

                            <!-- Properties Protested -->
                            <div class="p-3">
                                <p class="text-sm font-medium text-gray-500">
                                    Number of properties protested
                                </p>
                                <p class="mt-1 text-sm font-bold text-gray-900">
                                    {{ propertiesProtested }}
                                </p>
                            </div>

                            <!-- Total Value Reduction -->
                            <div class="p-3">
                                <p class="text-sm font-medium text-gray-500">
                                    Total value reduction
                                </p>
                                <p class="mt-1 text-sm font-bold text-gray-900">
                                    ${{ totalValueReduction }}
                                </p>
                            </div>

                            <!-- Tax Savings -->
                            <div class="p-3">
                                <p class="text-sm font-medium text-gray-500">
                                    Total estimated tax savings
                                </p>
                                <p class="mt-1 text-sm font-bold text-green-600">
                                    ${{ totalEstimatedTaxSaved }}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
                <user-property-data :user-properties="userProperties" :total-estimated-tax-saved="totalEstimatedTaxSaved" :service-cost="serviceCost" :outcome-reduction-type="outcomeReductionType"
                    v-on:go-to-feedback-form="goToFeedBackPage" :quick-options-button="quickOptionsButton" :reduction-vide-url="reductionVideUrl"
                    :is-include-quick-option="isIncludeQuickOption"
                    v-on:go-to-donate-page="goToDonatePage"></user-property-data>
            </div>
        </div>
    </div>
</template>

<script>
import { apiUrl, registrationYear } from "../../../../config/base.js";
import Message from "../FinalOutcome/Message.vue";
import UserPropertyData from "../FinalOutcome/UserPropertyData.vue";
import FeedbackForm from "../FinalOutcome/FeedbackForm.vue";
import DownloadFinalOrder from "../FinalOutcome/DownloadFinalOrder.vue";

export default {
    props: ['user', 'user-properties', 'signature', 'reduction-statement', 'total-estimated-tax-saved', 'service-cost',
        'donation-success', 'is-include-quick-option', 'quick-options-button', 'outcome-reduction-type', 'reduction-vide-url'],
    data() {
        return {
            currentUser: '',
            REGISTRATION_YEAR: registrationYear,
            countyName: 'Denton County',

        }
    },
    components: {
        Message,
        UserPropertyData,
        FeedbackForm,
        DownloadFinalOrder
    },
    created() {

        this.currentUser = this.user;

    },
    computed: {
        propertiesProtested() {
            return this.userProperties.filter(
                property => property.final_outcome_result
            ).length;
        },

        totalValueReduction() {
            return this.userProperties.reduce((total, property) => {
                return total + Number(
                    property.final_outcome_result?.amount_of_reduction || 0
                );
            }, 0);
        },
    },
    methods: {
        goToFeedBackPage() {
            window.location.href = apiUrl + '/protest-requests/final-outcome/show-feedback-form';
        },

        goToDonatePage() {
            window.location.href = apiUrl + '/protest-requests/final-outcome/show-donation-page';
        },
    }
}
</script>
